var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.isDataLoading)?_c('div',{staticClass:"loadingOverlay"},[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":""}})],1):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }